<template>
	<v-chip :color="Color" :small="small">
		{{ status.name }}
	</v-chip>
</template>

<script>
export default {
	props: {
		status: {
			type: Object,
			required: true,
		},

		small: {
			type: Boolean,
			default: false,
			required: false,
		},
	},

	data() {
		return {
			statuses: [],
		};
	},

	created() {
		let statuses = [];

		statuses[1] = {
			color: "default",
		};

		statuses[2] = {
			color: "primary",
		};

		this.statuses = statuses;
	},

	computed: {
		Color() {
			let status = this.statuses[this.status.id];

			if (status) {
				return status.color;
			}

			return "default";
		},
	},
};
</script>

<style lang="css" scoped></style>
